import { Joi } from 'app-webtech-core/schemas';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { VOLUME_CHANGE_NO_BEACON } from '../actions/types';

const payloadSchema = Joi.object().keys({
  up: Joi.boolean().required(),
  level: Joi.number().required(),
});

export const volumeChangeWithoutBeacon = actionCreator(VOLUME_CHANGE_NO_BEACON, payloadSchema);
